export default "<app-main></app-main>";